export class FindOneNoiseCatalogNumberRequest {
    makeName?: string;
    docNumber?:string;
}